export const selection_level = {
  PROVINCE: 0,
  CITY: 1,
};

export const request_type = {
  NORMALL: 0,
  FULL: 1,
  INSTANT: 2,
};

const newRequestTypes = {
  SET_SOURCE_LOCATION: "SET_SOURCE_LOCATION",
  SET_DESTINATION_LOCATION: "SET_DESTINATION_LOCATION",

  FETCH_CITIES_START: "FETCH_CITIES_START",
  FETCH_CITIES_SUCCESS: "FETCH_CITIES_SUCCESS",

  SET_SELECTED_PROVINCE: "SET_SELECTED_PROVINCE",
  SET_SELECTED_CITY: "SET_SELECTED_CITY",
  SET_SELECTION_LEVEL: "SET_SELECTION_LEVEL",

  SET_SELECTED_DISTRICT: "SET_SELECTED_DISTRICT",

  FETCH_VEHICLES_START: "FETCH_VEHICLES_START",
  FETCH_VEHICLES_SUCCESS: "FETCH_VEHICLES_SUCCESS",

  SET_SELECTED_VEHICLE: "SET_SELECTED_VEHICLE",

  FETCH_SUGGESTIONPRICE_START: "FETCH_SUGGESTIONPRICE_START",
  FETCH_SUGGESTIONPRICE_SUCCESS: "FETCH_SUGGESTIONPRICE_SUCCESS",
  SET_SHOWN_SUGGESTIONPRICE: "SET_SHOWN_SUGGESTIONPRICE",

  FETCH_LOADTYPES_START: "FETCH_LOADTYPES_START",
  FETCH_LOADTYPES_SUCCESS: "FETCH_LOADTYPES_SUCCESS",

  SET_BIMEH: "SET_BIMEH",
  SET_BARNAMEH: "SET_BARNAMEH",

  SET_LOADVALEU: "SET_LOADVALEU",

  SET_DESC_TAKHLIEH: "SET_DESC_TAKHLIEH",
  SET_DESC_BARGIRY: "SET_DESC_BARGIRY",

  SET_LOAD_WEIGHT: "SET_LOAD_WEIGHT",

  SET_SIZE_LENGTH: "SET_SIZE_LENGTH",
  SET_SIZE_WIDTH: "SET_SIZE_WIDTH",
  SET_SIZE_HEIGHT: "SET_SIZE_HEIGHT",

  SET_CALENDERTAKHLIEH_SHOW: "SET_CALENDERTAKHLIEH_SHOW",
  SET_CALENDERBARGIRY_SHOW: "SET_CALENDERBARGIRY_SHOW",

  FETCH_DAYSAHEAD_START: "FETCH_DAYSAHEAD_START",
  FETCH_DAYSAHEAD_SUCCESS: "FETCH_DAYSAHEAD_SUCCESS",

  SET_BARGIRY_DATE: "SET_BARGIRY_DATE",
  SET_BARGIRY_TIME: "SET_BARGIRY_TIME",

  SET_TAKHLIEH_DATE: "SET_TAKHLIEH_DATE",
  SET_TAKHLIEH_TIME: "SET_TAKHLIEH_TIME",
  SET_TAKHLIEH_TIMETO: "SET_TAKHLIEH_TIMETO",

  FETCH_AUCTIONLIST_START: "FETCH_AUCTIONLIST_START",
  FETCH_AUCTIONLIST_SUCCESS: "FETCH_AUCTIONLIST_SUCCESS",
  FETCH_AUCTIONLIST: "FETCH_AUCTIONLIST",
  SET_AUCTION: "SET_AUCTION",

  SET_DESC_LOAD: "SET_DESC_LOAD",

  SET_LOAD_TYPE: "SET_LOAD_TYPE",

  SET_TAKHLIEH_TIME_SHOW: "SET_TAKHLIEH_TIME_SHOW",

  SET_REQUEST_TYPE: "SET_REQUEST_TYPE",

  SET_PREREQ_TIME_SHOW: "SET_PREREQ_TIME_SHOW",

  SET_PREREQ_IS_TWO_WAY: "SET_PREREQ_IS_TWO_WAY",
  SET_VEHICLE_TYPE: "SET_VEHICLE_TYPE",
  PAYMENT_IN_DESTINATION: "PAYMENT_IN_DESTINATION",
  SET_RECEIVER_INFO: "SET_RECEIVER_INFO",
  SET_OTHER_DESTINATIONS_LOCATION: "SET_OTHER_DESTINATIONS_LOCATION",
  UPDATE_OTHER_DESTINATIONS_LOCATION: "UPDATE_OTHER_DESTINATIONS_LOCATION",
  SET_VEHICLE_REQUESTED_TYPE: "SET_VEHICLE_REQUESTED_TYPE",
  SET_LOADING_DESCRIPTION: "SET_LOADING_DESCRIPTION",
  SET_EVACUATION_DESCRIPTION: "SET_EVACUATION_DESCRIPTION",
  SET_PACKAGING_TYPE: "SET_PACKAGING_TYPE",
  SET_POSTAL_CODE: "SET_POSTAL_CODE",
  SET_ALERT_NOTIF_SHOW: "SET_ALERT_NOTIF_SHOW",
};

export default newRequestTypes;
